module.exports = __webpack_public_path__ + "img/sixpackcarrier36.d169737f.jpg";